import { Inline, Text } from 'braid-design-system';

import { VerifiedIdTickTooltip } from '../../VerifiedIdTickTooltip/VerifiedIdTickTooltip';

interface NameProps {
  displayName: string;
  digitalIdentity: {
    isVerified: boolean;
    verifiedName?: string | null;
  };
  isSignedIn: boolean;
}

export const Name = ({
  displayName,
  digitalIdentity,
  isSignedIn,
}: NameProps) => (
  <Text weight="strong" maxLines={1} size="large" data={{ role: 'heading' }}>
    <Inline space="xxsmall" alignY="center">
      <>{displayName}</>
      {digitalIdentity.isVerified ? (
        <VerifiedIdTickTooltip
          isSignedIn={isSignedIn}
          verifiedName={digitalIdentity.verifiedName}
          profileName={displayName}
        />
      ) : null}
    </Inline>
  </Text>
);
